export default "__VITE_ASSET__BPH1HMVw__"